import { ActionIcon, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

import { MenuTemplateStateEnum } from '@/api';

import { MENU_STATE_HELP_TEXT } from '../constants';

type MenuStatusHelpIconProps = {
  state: MenuTemplateStateEnum;
};

export const MenuStatusHelpIcon: React.FC<MenuStatusHelpIconProps> = ({ state }) => {
  const helpText = MENU_STATE_HELP_TEXT[state];

  if (!helpText) return null;

  return (
    <Tooltip
      label={helpText}
      multiline
      w={260}
      withArrow
      events={{ hover: true, focus: true, touch: true }}
    >
      <ActionIcon variant="subtle" color="gray" size="sm" aria-label="Menu status help">
        <IconInfoCircle size={16} />
      </ActionIcon>
    </Tooltip>
  );
};
